import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetOrder } from '../../operations';

const initialState = null as DeliveryFee | null;

const slice = createSlice({
  name: '$deliveryFee',
  initialState,
  reducers: {
    setDeliveryFee(_state, action: PayloadAction<DeliveryFee | null>) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetOrder, () => initialState);
  },
});

export const { setDeliveryFee } = slice.actions;
export default slice.reducer;
